@if (showLoader) {
<app-loader></app-loader>
}
@if (gridConfig) {
<div [style.height.px]="gridHeight">
    <inavista-grid #cycleCountOpenExceptionGrid class="so-popup-grid"
        [config]="gridConfig"
        (rowsSelected)="onRowsSelected($event)"
        (hyperlinkClick)="onHyperlinkClick($event)"
        (toolbarActionClick)="onToolbarActionClick($event)"
        (exportRequested)="onExportRequested()" />
</div>
}

@if (showAdjustmentOrderListPopup) {
<app-ms-dynamic-modal

    pageId="PG0000161"
    modalTitle="Adjustment Orders"
    modalTitleLabel="The Following adjustment order(s) were created"
    [data]="adjustmentOrdersList"
    (onClose)="adjustmentOrderListPopupClosed($event)"
></app-ms-dynamic-modal>
}

@if (linkedPopupData) {
<app-linked-popup-opener

    [data]="linkedPopupData"
    (onPopupClose)="linkedPopupData = null;"
></app-linked-popup-opener>
}
